import { useNavigate } from 'react-router-dom';
import './about.css';
import logo from '../../Assets/images/banner-logo.png'; // adjust if needed

const AboutPageDetail = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      {/* Header */}
      <header className="about-header">
        <img
          src={logo}
          alt="SDSS Site Inspect Logo"
          className="about-logo"
          onClick={() => navigate('/')}
        />
        <h1>About</h1>
      </header>

      {/* Main Content */}
      <main className="about-content">
        <p>
          <strong>Site Inspect</strong> is SDSS’s digital inspection application,
          designed to support inspectors in completing site inspections efficiently,
          consistently, and securely using mobile devices.
        </p>

        <p>
          The app replaces paper-based processes and manual data entry with a
          streamlined digital workflow that allows inspectors to capture inspection
          information, photographs, notes, and outcomes directly on-site using
          SDSS-issued iPads.
        </p>

        <h2>What Site Inspect Does</h2>
        <p>Site Inspect supports inspectors to:</p>
        <ul>
          <li>Access assigned inspections digitally</li>
          <li>Complete inspection checklists and forms in real time</li>
          <li>Capture and attach photos and supporting evidence</li>
          <li>Record notes, issues, and observations on site</li>
          <li>Submit inspection results securely from the field</li>
          <li>
            Work offline when connectivity is limited, with automatic syncing when
            back online
          </li>
        </ul>

        <p>
          By digitising inspections, Site Inspect helps improve data quality, reduce
          rework, and ensure inspection records are complete, accurate, and timely.
        </p>

        <h2>Why Site Inspect Was Introduced</h2>
        <p>Site Inspect has been introduced to:</p>
        <ul>
          <li>Improve consistency across inspections</li>
          <li>Reduce reliance on paper and manual processes</li>
          <li>Enable faster submission and review of inspection data</li>
          <li>Support inspectors with a mobile-first, user-friendly tool</li>
          <li>Strengthen data security and record management</li>
        </ul>

        <p>
          The app is designed to fit into existing inspection workflows while making
          it easier to capture information at the point of inspection.
        </p>

        <h2>Devices and Access</h2>
        <p>
          Site Inspect is used on SDSS-issued Apple iPads and is managed in accordance
          with SDSS device, security, and acceptable use policies. Access to the app
          is restricted to authorised users and requires secure sign-in.
        </p>

        <h2>Data, Security and Privacy</h2>
        <p>
          All inspection data captured in Site Inspect is handled in line with SDSS
          policies and relevant privacy and information security requirements. Data
          is stored securely and is only accessible to authorised personnel for
          legitimate business purposes.
        </p>

        <h2>Support and Help</h2>
        <p>
          If you need help using Site Inspect, experience technical issues, or have
          questions about access or functionality, please visit the Support page for
          guidance, resources, and contact details.
        </p>

        <p className="about-note">
          Site Inspect is an evolving platform. Feedback from inspectors is
          encouraged and will help inform future improvements and enhancements.
        </p>
      </main>

      {/* Footer */}
      <footer className="about-footer">
        © 2026 Site Inspect. All rights reserved.
      </footer>
    </div>
  );
};

export default AboutPageDetail;
